import type { Element } from "React";
type Props = {
  className?: string;
};

const LogoNeteller = (props: Props): Element<"svg"> => (
  <svg
    className={`neteller-logo ${props.className}`}
    version="1.1"
    viewBox="0 0 300 51.841892"
  >
    <path
      d="m294.51 3.94c-3.8228-2.6191-9.6088-3.94-17.193-3.94h-19.862l-7.3841 40.087h-26.02l1.6724-9.0949h15.674l1.8573-10.215-15.665 0.02254 1.677-9.0543h16.145l2.1481-11.743h-32.787l-7.0099 38.025h-12.032l7.0573-38.027h-17.139l-7.0099 38.025h-11.721l7.064-38.025h-17.13l-7.3931 40.087h-26.207l1.6567-9.0949h15.737l1.8596-10.157-15.722-0.01577 1.668-9.0723h16.326l2.1345-11.748h-102.17l-5.8153 31.766-11.581-31.766h-17.782l-9.5705 51.842h16.982l5.7928-32.642 11.238 32.642h60.862l7.3999-40.099h9.5186l-7.3998 40.099h160.14l4.6432-25.312 7.5103 25.312h16.991l-7.783-20.683 1.7807-0.38318c3.9219-0.84074 6.9806-2.6462 9.1106-5.3532 2.1278-2.7318 3.212-6.2391 3.212-10.452 0-4.9047-1.7942-8.5133-5.4862-11.033zm-214.42 36.147h-25.995l1.6792-9.0949h16.305l1.8483-10.244h-16.148l1.5553-9.0002h25.957l-5.2067 28.339zm200.42-17.462c-1.7085 1.1946-4.1857 1.7761-7.5734 1.7761h-3.3585l2.5763-13.912h2.4704c2.813 0 4.8641 0.4508 6.2796 1.3704 1.1045 0.72128 2.4185 2.1481 2.4185 4.8461-4e-3 3.2638-1.5327 5.0174-2.8175 5.919z"
      fill="#83ba3b"
      strokeWidth="2.254"
    />
  </svg>
);

export default LogoNeteller;
